import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {
  AirTicketsResourceService,
  FlightSegment,
  GroupPricedItinerary
} from '@gtd/b2c-client';
import { Subscription } from 'rxjs';
import { environment } from '@env/environment';
import { Router } from '@angular/router';
import { FareRules } from '@gtd/api-services/b2b-client';
import { FarerulesFacade } from '../../search-result/flight/flight-search/farerules/+state/farerules.facade';
import { ComboSelectedService } from '@gtd/components/combo-flight-booking-item';

@Component({
  selector: 'gtd-flight-booking-item',
  templateUrl: './flight-booking-item.component.html',
  styleUrls: ['./flight-booking-item.component.scss'],
  encapsulation:
    environment.appName === 'B2B2C'
      ? ViewEncapsulation.None
      : ViewEncapsulation.Emulated
})
export class FlightBookingItemComponent
  implements OnInit, OnDestroy, AfterContentChecked {
  @Input() groupPricedItinerary: GroupPricedItinerary;
  @Input() bookingNumber: string;
  @Input() bookingDirectionIndex: number;
  @Input() searchId: string;
  @Input() params: any;
  @Input() pricedItinerary;
  flightSegments?: Array<FlightSegment>;
  allFarerules: FareRules[];
  subscriptions = new Subscription();
  isDetailJourney: boolean;
  panelOpenState: boolean;

  submitLoadMore = false;

  constructor(
    private cdref: ChangeDetectorRef,
    private farerulesFacade: FarerulesFacade,
    private airTicketsResourceService: AirTicketsResourceService,
    private _comboSelectedService: ComboSelectedService,
    public router: Router
  ) {}

  ngOnInit() {
    setTimeout(() => {
      if (this.groupPricedItinerary) {
        this.flightSegments = this.groupPricedItinerary.pricedItineraries[0].originDestinationOptions[0].flightSegments;
      }
    });

    this.subscriptions.add(
      this.farerulesFacade.allFarerules$.subscribe(allFarerules => {
        if (allFarerules) {
          this.allFarerules = allFarerules.fareRules;
          this.submitLoadMore = false;
        }
      })
    );
  }
  getFareRules() {
    this.submitLoadMore = true;
    const currentLanguage = localStorage.getItem('language');
    // this.fareSourceCode = fareSourceCode;
    this.farerulesFacade.loadAll(
      {
        fareSourceCode: this.pricedItinerary.airItineraryPricingInfo
          .fareSourceCode,
        groupId: this.groupPricedItinerary.groupId,
        searchId: this.searchId
      },
      currentLanguage
    );
  }
  resetFlight(type: 'from' | 'to') {
    this._comboSelectedService.removeFlight(
      type,
      this.pricedItinerary.airItineraryPricingInfo.itinTotalFare.totalFare
        .amount
    );
    this.router.navigate(['/combo/flight'], {
      queryParams: {
        params: this.params.params,
        hotel: this.params.hotel
      }
    });
  }
  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
